// Enum for available features
export enum Features {
  SISU_INTEGRATION = 'SISU_INTEGRATION',
  ZILLOW_INTEGRATION = 'ZILLOW_INTEGRATION',
  REALTOR_INTEGRATION = 'REALTOR_INTEGRATION',
  PROACTIVE_CALL = 'PROACTIVE_CALL',
  PROACTIVE_SMS = 'PROACTIVE_SMS',
  AGENT_LEVEL_DAILY_SYNC = 'AGENT_LEVEL_DAILY_SYNC',
  ASYNC_AGENT_CONVERSATION_PROCESSING = 'ASYNC_AGENT_CONVERSATION_PROCESSING',
  // Add more features as needed
}

export enum FeatureValue {
  ALL = 'all',
  DISABLED = 'disabled',
  AGENTS = 'agents',
  ENABLED = 'enabled',
  SHADOW = 'shadow',
  LIVE = 'live',
}

// Loose-typed: backend is the source of truth for which flags exist. The
// curated display set lives in `components/client/feature-display.ts`.
export type ClientFeatures = Record<string, FeatureValue>;

// Interface representing a client feature
export interface ClientFeature {
  id: number;
  clientConfigId: number;
  featureName: Features;
  featureValue: FeatureValue;
  createdAt: Date;
  updatedAt: Date;
  deprecated?: boolean;
}

// Interface for creating/updating a client feature
export interface ClientFeatureInput {
  clientConfigId: number;
  featureName: Features;
  featureValue: FeatureValue;
}

export interface AgentFeature {
  id?: string;
  feature_name: string;
  feature_enabled?: boolean;
  deprecated?: boolean;
}
